enum ProviderEnum {
  LT = 'LT',
  CONECTA_ENEM = 'CONECTAENEM',
  SABE2ED = 'SABE2ED',
  PRUVO = 'PRUVO'
}

export default ProviderEnum
